import { FC, useState, useEffect } from 'react'
import {
  Route,
  Redirect,
} from 'react-router-dom'
import { useDispatch } from 'react-redux'

import CONFIG from '../../config'
import { AuthRoles } from '../models'
import { authService } from '../services'
import { authActions } from '../store/actions'

interface IRouteAuthedProps {
  component: any,
  path?: string,
  role?: AuthRoles,
  exact?: boolean
}

const RouteAuthed: FC<IRouteAuthedProps> = ({ component, path, role = '', ...rest }) => {
  const dispatch = useDispatch()
  const [isLoggedIn, setIsLoggedIn] = useState<boolean | null>(null)
  let redirectTo = CONFIG.ROUTES.HOME

  useEffect(() => {
    setIsLoggedIn(authService.isLoggedIn(role))
  }, [role])

  const getRoute = () => <Route component={component} path={path} {...rest} />

  if(isLoggedIn === null) return null

  if(role === CONFIG.AUTH.ROLES.ADMIN || role === CONFIG.AUTH.ROLES.SUPERADMIN) {
    if(isLoggedIn) {
      const userCurrent: any = authService.getUserCurrentStorage()
      const { info } = userCurrent
      const userRole: string = info?.rol

      // si el rol requerido en las props es admin y el usuario es admin o superadmin
      if(role === CONFIG.AUTH.ROLES.ADMIN && (userRole === CONFIG.AUTH.ROLES.ADMIN || userRole === CONFIG.AUTH.ROLES.SUPERADMIN)) {
        authService.setUserCurrentPageRole(role)
        dispatch(authActions.getUserCurrentStorage())
        return getRoute()
      }

      // si el rol requerido en las props es superadmin y el usuario es superadmin
      if(role === CONFIG.AUTH.ROLES.SUPERADMIN && userRole === CONFIG.AUTH.ROLES.SUPERADMIN) {
        authService.setUserCurrentPageRole(role)
        dispatch(authActions.getUserCurrentStorage())
        return getRoute()
      }
      
    }
    redirectTo = CONFIG.ROUTES.ADMIN.HOME

  } else if(isLoggedIn) {
    authService.setUserCurrentPageRole(role)
    dispatch(authActions.getUserCurrentStorage())
    return getRoute()
  }

  return <Redirect to={redirectTo} {...rest} />
}

export { RouteAuthed }